<template>
  <div>
    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/escola"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ textoBuscaApi(propSlot.item) }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-card class="mt-1 mb-3">
      <div class="escola-card-dados">
        <div><span><b>Nome escola</b>: {{ form.nomeescola }}</span> </div>
        <div><span><b>Nome abreviado</b>: {{ form.nomeabreviado }}</span> </div>
        <div class="escola-card-dados-itens">
          <div><b>INEP</b>: {{ form.numeroinep }}</div>
          <div><b>Dependência Administrativa</b>: {{ exibeDependencia() }}</div>
          <div><b>Situação de Funcionamento</b>: {{ exibeSituacao() }}</div>
          <div><b>Zona de Localização</b>: {{ exibeZonaLocalizacao() }}</div>
        </div>
      </div>
    </v-card>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty">
            Preencha os campos corretamente.
            <span v-if="$v.form.nomeescola.$invalid ||
                        $v.form.nomeabreviado.$invalid ||
                        $v.form.tipodependenciaadministrativa.$invalid ||
                        $v.form.tiposituacaofuncionamento.$invalid ||
                        $v.form.tipozonalocalizacao.$invalid ||
                        $v.form.numeroinep.$invalid

            "> Verificar aba PRINCIPAL.</span>
            <span v-if="$v.form.codigologradouro.$invalid ||
                        $v.form.numeroimovel.$invalid ||
                        $v.form.descricaocomplementoendereco.$invalid ||
                        $v.form.descricaoemailescola.$invalid ||
                        $v.form.nomecidadeinternacionalescola.$invalid ||
                        $v.form.nomepaisinternacionalescola.$invalid ||
                        $v.form.indicanacionalidadeescola.$invalid

            "> Verificar aba DADOS GERAIS.</span>
            <span v-if="$v.form.cnpjescola.$invalid ||
                        $v.form.anoparecer.$invalid ||
                        $v.form.numeroparecer.$invalid ||
                        $v.form.anoportaria.$invalid ||
                        $v.form.numeroportariaseesme.$invalid ||
                        $v.form.datapublicacaoportaria.$invalid ||
                        $v.form.anoleicriacao.$invalid ||
                        $v.form.numeroleicriacao.$invalid ||
                        $v.form.numeroleidenominacao.$invalid ||
                        $v.form.numeroautorizacaofuncionamento.$invalid ||
                        $v.form.datainiciofuncionamento.$invalid ||
                        $v.form.dataextincao.$invalid

            "> Verificar aba DOCUMENTAÇÃO.</span>
            <span v-if="$v.form.indicaescolaanexa.$invalid ||
                        $v.form.descricaoescolasede.$invalid ||
                        $v.form.tipocategoriaescolaprivada.$invalid ||
                        $v.form.tipomantenedoraescolaprivada.$invalid ||
                        $v.form.tipolocalizadiferenciadaescola.$invalid ||
                        $v.form.cnpjmantenedoraprincipal.$invalid ||
                        $v.form.cnpjescolaprivada.$invalid ||
                        $v.form.nomesuperitendenciaensino.$invalid ||
                        $v.form.tipoorgaoescolavinculada.$invalid ||
                        $v.form.tiposituacaoregulamentacao.$invalid ||
                        $v.form.tipoatendimentoescola.$invalid
            "> Verificar aba CARACTERÍSTICAS.</span>
      </div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novaEscola"
      :editar="editarEscola"
      :excluir="excluirEscola"
      :cancelar="cancelarEscola"
      :id="form.identificadorescola"
      class="mb-3">
      <v-tabs>
        <v-tab>Principal</v-tab>
        <v-tab>Dados Gerais</v-tab>
        <v-tab>Documentação</v-tab>
        <v-tab>Características</v-tab>

        <v-tab-item>
          <v-card class="pa-3">
            <!-- Id escola -->
            <Input type="text" label="Código Escola" disabled v-model="form.identificadorescola" />
            <Input type="text" label="Nome Escola" :disabled="desabilitarCampos()" ref="focusCampo" v-model="form.nomeescola" :v="$v.form.nomeescola"/>
            <Input type="text" label="Nome Abreviado" :disabled="desabilitarCampos()" v-model="form.nomeabreviado" :v="$v.form.nomeabreviado" />
            <Input type="text" :disabled="desabilitarCampos()" label="Nº do INEP" v-model="form.numeroinep" :v="$v.form.numeroinep" />
            <Validator label="Dependência Administrativa" :disabled="desabilitarCampos()" :v="$v.form.tipodependenciaadministrativa">
              <Radio v-model="form.tipodependenciaadministrativa" :disabled="desabilitarCampos()" val="1" label="Federal"/>
              <Radio v-model="form.tipodependenciaadministrativa" :disabled="desabilitarCampos()" val="2" label="Estadual"/>
              <Radio v-model="form.tipodependenciaadministrativa" :disabled="desabilitarCampos()" val="3" label="Municipal"/>
              <Radio v-model="form.tipodependenciaadministrativa" :disabled="desabilitarCampos()" val="4" label="Privada"/>
            </Validator>
            <Validator label="Situação de Funcionamento" :v="$v.form.tiposituacaofuncionamento">
              <Radio v-model="form.tiposituacaofuncionamento" :disabled="acao == ''" val="1" @blur="$v.form.tiposituacaofuncionamento.$touch()" label="Em Atividade"/>
              <Radio v-model="form.tiposituacaofuncionamento" :disabled="acao == ''" val="2" @blur="$v.form.tiposituacaofuncionamento.$touch()" label="Paralisada"/>
              <Radio v-model="form.tiposituacaofuncionamento" :disabled="acao == ''" val="3" @blur="$v.form.tiposituacaofuncionamento.$touch()" label="Extinta"/>
            </Validator>
            <Validator label="Zona de Localização" :v="$v.form.tipozonalocalizacao">
              <Radio v-model="form.tipozonalocalizacao" :disabled="desabilitarCampos()" val="1" @blur="$v.form.tipozonalocalizacao.$touch()" label="Urbana"/>
              <Radio v-model="form.tipozonalocalizacao" :disabled="desabilitarCampos()" val="2" @blur="$v.form.tipozonalocalizacao.$touch()" label="Rural"/>
            </Validator>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="pa-3">
            <!--código logradouro-->
            <Endereco
              :acao="acao"
              :numero.sync="form.numeroimovel"
              :complemento.sync="form.descricaocomplementoendereco"
              :codigologradouro.sync="form.codigologradouro"
              :validation="validacaoEndereco()"
              :desabilitar="form.indicanacionalidadeescola == 'I' || (acao == 'editar' && form.tiposituacaofuncionamento == '3')"
              :vNumero="$v.form.numeroimovel"
              :vComplemento="$v.form.descricaocomplementoendereco" />
            <InputMask :mask="['(##) ####-####', '(##) #####-####']" label="Telefone" :disabled="desabilitarCampos()" v-model="form.numerotelefone" :v="$v.form.numerotelefone"/>
            <Input type="number" label="Ramal da Escola" :disabled="desabilitarCampos()" max="9999" v-model="form.numeroramalescola" :v="$v.form.numeroramalescola"/>
            <Input type="text" label="E-mail Oficial" :disabled="desabilitarCampos()" v-model="form.descricaoemailescola" :v="$v.form.descricaoemailescola" @input="form.descricaoemailescola = form.descricaoemailescola.toLowerCase();"/>
            <Validator label="Nacionalidade da Escola" :disabled="desabilitarCampos()" :v="$v.form.indicanacionalidadeescola">
              <Radio v-model="form.indicanacionalidadeescola" val="B" :disabled="desabilitarCampos()" label="Brasileira"/>
              <Radio v-model="form.indicanacionalidadeescola" val="I" :disabled="desabilitarCampos()" label="Internacional"/>
            </Validator>
            <Input type="text" :disabled="form.indicanacionalidadeescola != 'I' || desabilitarCampos()" label="Nome da Cidade Internacional" v-model="form.nomecidadeinternacionalescola" :v="$v.form.nomecidadeinternacionalescola" />
            <Input type="text" :disabled="form.indicanacionalidadeescola != 'I' || desabilitarCampos()" label="Nome do País" v-model="form.nomepaisinternacionalescola" :v="$v.form.nomepaisinternacionalescola" />
            <Input type="text" disabled v-model="form.latitude" readonly label="Latitude" />
            <Input type="text" disabled v-model="form.longitude" readonly label="Longitude" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="pa-3">
            <InputMask mask="##.###.###/####-##" label="CNPJ Escola" :disabled="desabilitarCampos()" v-model="form.cnpjescola" :v="$v.form.cnpjescola"/>
            <Input type="number" label="Ano parecer C.E.E/ C.M.E" :disabled="desabilitarCampos()" v-model.trim="form.anoparecer" :v="$v.form.anoparecer"/>
            <Input type="number" label="Nº parecer C.E.E/ C.M.E" :disabled="desabilitarCampos()" v-model.trim="form.numeroparecer" :v="$v.form.numeroparecer"/>
            <Input type="number" label="Ano portaria S.E.E/ S.M.E" :disabled="desabilitarCampos()" v-model.trim="form.anoportaria" :v="$v.form.anoportaria"/>
            <Input type="text" label="Nº portaria S.E.E/ S.M.E" :disabled="desabilitarCampos()" v-model.trim="form.numeroportariaseesme" :v="$v.form.numeroportariaseesme"/>
            <InputDate placeholder="dd/mm/aaaa" label="Data da publicação da portaria" :disabled="desabilitarCampos()" v-model="form.datapublicacaoportaria" :v="$v.form.datapublicacaoportaria"/>
            <Input type="number" label="Ano da Lei de criação" :disabled="desabilitarCampos()" v-model.trim="form.anoleicriacao" :v="$v.form.anoleicriacao"/>
            <Input type="number" label="Nº da lei de Criação" :disabled="desabilitarCampos()" v-model.trim="form.numeroleicriacao" :v="$v.form.numeroleicriacao"/>
            <Input type="number" label="Nº da lei de Denominação" :disabled="desabilitarCampos()" v-model.trim="form.numeroleidenominacao" :v="$v.form.numeroleidenominacao"/>
            <Input type="number" label="Nº de autorização de funcionamento" :disabled="desabilitarCampos()" v-model.trim="form.numeroautorizacaofuncionamento" :v="$v.form.numeroautorizacaofuncionamento"/>
            <InputDate placeholder="dd/mm/aaaa" label="Data Início de Funcionamento" :disabled="desabilitarCampos()" v-model="form.datainiciofuncionamento" :v="$v.form.datainiciofuncionamento"/>
            <InputDate label="Data de Extinção" :disabled="acao == '' || form.tiposituacaofuncionamento != '3'" v-model="form.dataextincao" :v="$v.form.dataextincao"/>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="pa-3">
            <Validator label="Escola Anexa?" :v="$v.form.indicaescolaanexa">
              <Radio v-model="form.indicaescolaanexa" val="S" :disabled="desabilitarCampos()" @blur="$v.form.indicaescolaanexa.$touch()" label="Sim"/>
              <Radio v-model="form.indicaescolaanexa" val="N" :disabled="desabilitarCampos()" @blur="$v.form.indicaescolaanexa.$touch()" label="Não"/>
            </Validator>
            <Input type="text" label="Escola Sede" v-model="form.descricaoescolasede" :disabled="form.indicaescolaanexa != 'S' || desabilitarCampos()" :v="$v.form.descricaoescolasede" />
            <Validator label="Categoria da Escola Privada" :v="$v.form.tipocategoriaescolaprivada">
              <Radio v-model="form.tipocategoriaescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="1" label="Particular"/>
              <Radio v-model="form.tipocategoriaescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="2" label="Comunitária"/>
              <Radio v-model="form.tipocategoriaescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="3" label="Confessional"/>
              <Radio v-model="form.tipocategoriaescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="4" label="Filantrópica"/>
            </Validator>
            <Validator label="Conveniada com Poder Público" :v="$v.form.tipoconveniadapoderpublico" >
              <Radio v-model="form.tipoconveniadapoderpublico" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="1" label="Estadual"/>
              <Radio v-model="form.tipoconveniadapoderpublico" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="2" label="Municipal"/>
              <Radio v-model="form.tipoconveniadapoderpublico" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="3" label="Estadual e Municipal"/>
            </Validator>
            <Validator label="Mantenedora da Escola Privada" :v="$v.form.tipomantenedoraescolaprivada" >
              <Radio v-model="form.tipomantenedoraescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="1" label="Empresas, grupos empresariais do setor privado ou pessoa física."/>
              <Radio v-model="form.tipomantenedoraescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="2" label="ONG - Organização não governamental - internacional ou nacional/Oscip."/>
              <Radio v-model="form.tipomantenedoraescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="3" label="Sistemas S (Sesi, Senai, Sesc, outros)"/>
              <Radio v-model="form.tipomantenedoraescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="4" label="Sindicatos de trabalhadores ou patronais, associações, cooperativas."/>
              <Radio v-model="form.tipomantenedoraescolaprivada" :disabled="form.tipodependenciaadministrativa != '4' || desabilitarCampos()" val="5" label="Instituições sem fins lucrativos."/>
            </Validator>
            <Validator label="Localização Diferenciada da Escola" :v="$v.form.tipolocalizadiferenciadaescola" >
              <Radio v-model="form.tipolocalizadiferenciadaescola" :disabled="desabilitarCampos() || form.tipozonalocalizacao == 1" val="1" label="Área de assentamento"/>
              <Radio v-model="form.tipolocalizadiferenciadaescola" :disabled="desabilitarCampos() || form.tipozonalocalizacao == 1" val="2" label="Terra indígena"/>
              <Radio v-model="form.tipolocalizadiferenciadaescola" :disabled="desabilitarCampos() || form.tipozonalocalizacao == 1" val="3" label="Área onde se localiza comunidade remanescente de quilombos"/>
              <Radio v-model="form.tipolocalizadiferenciadaescola" :disabled="desabilitarCampos() || form.tipozonalocalizacao == 1" val="7" label="A escola não está em área de localização diferenciada"/>
            </Validator>
            <InputMask mask="##.###.###/####-##" label="CNPJ da mantenedora PRINCIPAL da Escola Privada" :v="$v.form.cnpjmantenedoraprincipal" v-model="form.cnpjmantenedoraprincipal" :disabled="!(form.tipomantenedoraescolaprivada == '5' && form.tipodependenciaadministrativa == '4') || desabilitarCampos()" />
            <InputMask mask="##.###.###/####-##" label="CNPJ da Escola Privada" :v="$v.form.cnpjescolaprivada" v-model="form.cnpjescolaprivada" :disabled="desabilitarCampos() || form.tipodependenciaadministrativa != '4'" />
            <Input type="text" v-model="form.nomesuperitendenciaensino" :v="$v.form.nomesuperitendenciaensino" :disabled="desabilitarCampos()" label="Superintendência / Sistema de Ensino" />
            <Validator label="Órgão que a escola Pública está vinculada" :v="$v.form.tipoorgaoescolavinculada">
              <Radio v-model="form.tipoorgaoescolavinculada" val="1" :disabled="form.tipodependenciaadministrativa == '4' || desabilitarCampos()" label="Secretaria de Educação/Ministério da Educação"/>
              <Radio v-model="form.tipoorgaoescolavinculada" val="2" :disabled="form.tipodependenciaadministrativa == '4' || desabilitarCampos()" label="Secretaria de Segurança Pública/Forças Armadas/Militar"/>
              <Radio v-model="form.tipoorgaoescolavinculada" val="3" :disabled="form.tipodependenciaadministrativa == '4' || desabilitarCampos()" label="Secretaria da Saúde/Ministério da Saúde"/>
              <Radio v-model="form.tipoorgaoescolavinculada" val="4" :disabled="form.tipodependenciaadministrativa == '4' || desabilitarCampos()" label="Outro órgão da administração pública"/>
            </Validator>
            <Validator label="Regulamentação/Autorização no Conselho ou Órgão Público de educação" :v="$v.form.tiposituacaoregulamentacao">
              <Radio v-model="form.tiposituacaoregulamentacao" :disabled="desabilitarCampos()" val="1" label="Não"/>
              <Radio v-model="form.tiposituacaoregulamentacao" :disabled="desabilitarCampos()" val="2" label="Sim"/>
              <Radio v-model="form.tiposituacaoregulamentacao" :disabled="desabilitarCampos()" val="3" label="Em tramitação"/>
            </Validator>
            <Validator label="Tipo de Atendimento">
              <Radio v-model="form.tipoatendimentoescola" :disabled="desabilitarCampos()" val="1" label="Escola"/>
              <Radio v-model="form.tipoatendimentoescola" :disabled="desabilitarCampos()" val="2" label="Creche"/>
              <Radio v-model="form.tipoatendimentoescola" :disabled="desabilitarCampos()" val="3" label="Escola Comunitária"/>
            </Validator>
            <Input type="time" :disabled="desabilitarCampos()" v-model="form.horariofuncionamentoinicio" label="Horário de Funcionamento Início"/>
            <Input type="time" :disabled="desabilitarCampos()" v-model="form.horariofuncionamentofim" label="Horário de Funcionamento Fim"/>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/api';
import Endereco from '@/components/Endereco';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer, email, between, alphaNum,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';
import {validaCnpj} from '@/utils/validaCnpj';

const setFormInicial = () => ({
  identificadorescola: '',
  codigologradouro: '',
  nomeescola: '',
  tiposituacaofuncionamento: '1',
  tipodependenciaadministrativa: '3',
  tipozonalocalizacao: '1',
  anoleicriacao: '',
  anoparecer: '',
  anoportaria: '',
  tipocategoriaescolaprivada: '',
  cnpjescola: '',
  cnpjescolaprivada: '',
  cnpjmantenedoraprincipal: '',
  numeroimovel: '',
  descricaocomplementoendereco: '',
  tipoconveniadapoderpublico: '',
  dataalteracao: '',
  dataextincao: '',
  datainiciofuncionamento: '',
  datapublicacaoportaria: '',
  descricaoemailescola: '',
  descricaoescolasede: '',
  horariofuncionamentofim: '',
  horariofuncionamentoinicio: '',
  indicaescolaanexa: 'N',
  tipolocalizadiferenciadaescola: '',
  tipomantenedoraescolaprivada: '',
  nomeabreviado: '',
  nomesuperitendenciaensino: '',
  numeroautorizacaofuncionamento: '',
  numeroinep: '',
  numeroleicriacao: '',
  numeroleidenominacao: '',
  numeroparecer: '',
  numeroportariaseesme: '',
  tipoorgaoescolavinculada: '1',
  numeroramalescola: '',
  tiposituacaoregulamentacao: '',
  numerotelefone: '',
  tipoatendimentoescola: '1',
  nomecidadeinternacionalescola: '',
  nomepaisinternacionalescola: '',
  indicanacionalidadeescola: 'B',
  latitude: '',
  longitude: '',
});

export default {
  name: 'escola',
  components: {
    Endereco,
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'nomeescola',
      buscaOptions: [
        { value: 'identificadorescola', text: 'Código Escola' },
        { value: 'nomeescola', text: 'Nome Escola' },
        { value: 'numeroinep', text: 'Número do INEP' },
      ],
    };
  },
  validations() {
    return {
      form: {
        codigologradouro: { required: ((this.form.indicanacionalidadeescola == 'B') ? required : '') },
        nomeescola: {
          required, maxLength: maxLength(100), alphaSpace, minLength: minLength(4),
        },
        tiposituacaofuncionamento: { required },
        tipodependenciaadministrativa: { required },
        tipozonalocalizacao: { required },
        anoleicriacao: { maxLength: maxLength(4), integer, minLength: minLength(4) },
        anoparecer: { maxLength: maxLength(4), integer, minLength: minLength(4) },
        anoportaria: { maxLength: maxLength(4), integer, minLength: minLength(4) },
        tipocategoriaescolaprivada: { required: ((this.form.tipodependenciaadministrativa == '4') ? required : '') },
        cnpjescola: { maxLength: maxLength(14), minLength: minLength(14), validaCnpj },
        cnpjescolaprivada: { maxLength: maxLength(14), minLength: minLength(14), validaCnpj },
        cnpjmantenedoraprincipal: { validaCnpj, maxLength: maxLength(14), minLength: minLength(14), required: ((this.form.tipomantenedoraescolaprivada == '5') ? required : '') },
        numeroimovel: { maxLength: maxLength(10), integer },
        descricaocomplementoendereco: { maxLength: maxLength(20) }, // colocar na api
        descricaoemailescola: { email, maxLength: maxLength(50) },
        descricaoescolasede: { maxLength: maxLength(100), required: ((this.form.indicaescolaanexa == 'S') ? required : '') },
        tipolocalizadiferenciadaescola: { required: ((this.form.tipozonalocalizacao == 2) ? required : ''), between: between(1, 7) },
        nomeabreviado: { maxLength: maxLength(30), alphaSpace },
        nomesuperitendenciaensino: { maxLength: maxLength(60) },
        numeroautorizacaofuncionamento: { maxLength: maxLength(18), integer },
        numeroinep: { minLength: minLength(8), maxLength: maxLength(8), integer },
        numeroleicriacao: { maxLength: maxLength(4), integer },
        numeroleidenominacao: { maxLength: maxLength(18), integer },
        numeroparecer: { maxLength: maxLength(18), integer },
        numeroportariaseesme: { maxLength: maxLength(7), alphaNum },
        numeroramalescola: { maxLength: maxLength(4), integer },
        tiposituacaoregulamentacao: { required: ((this.form.indicanacionalidadeescola == 'B') ? required : '') },
        numerotelefone: { maxLength: maxLength(11), minLength: minLength(10) },
        tipoatendimentoescola: { required },
        nomecidadeinternacionalescola: { maxLength: maxLength(72), required: ((this.form.indicanacionalidadeescola == 'I') ? required : '') },
        nomepaisinternacionalescola: { maxLength: maxLength(72), required: ((this.form.indicanacionalidadeescola == 'I') ? required : '') },
        indicanacionalidadeescola: { required },
        tipomantenedoraescolaprivada: { required: ((this.form.tipodependenciaadministrativa == '4') ? required : '') },
        tipoorgaoescolavinculada: { required: ((this.form.tipodependenciaadministrativa != '4') ? required : '') },
        datapublicacaoportaria: { minLength: minLength(10), isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        datainiciofuncionamento: { minLength: minLength(10), isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        indicaescolaanexa: { required },
        numeroimovel: { required: ((this.form.indicanacionalidadeescola == 'B') ? required : ''), maxLength: maxLength(9) },
        descricaocomplementoendereco: { maxLength: maxLength(255) },
        dataextincao: { required: ((this.form.tiposituacaofuncionamento == '3') ? required : ''), isValidDate: (value) => (value) ? moment(value, 'DD/MM/YYYY').isValid() : true },
      },
    };
  },
  watch: {
    form: {
      handler(val) {
        if (val.indicaescolaanexa == 'N') { this.form.descricaoescolasede = ''; }

        if (val.tipodependenciaadministrativa != '4') {
          this.form.tipocategoriaescolaprivada = '';
          this.form.tipomantenedoraescolaprivada = '';
          this.form.cnpjmantenedoraprincipal = '';
          this.form.tipoconveniadapoderpublico = '';
          this.form.cnpjescolaprivada = '';
        } else {
          this.form.tipoorgaoescolavinculada = '';

          if (val.tipomantenedoraescolaprivada != '5') {
            this.form.cnpjmantenedoraprincipal = '';
          }
        }

        this.form.tipolocalizadiferenciadaescola = (val.tipozonalocalizacao == '1') ? '7' : val.tipolocalizadiferenciadaescola;

        if (val.indicanacionalidadeescola != 'I') {
          this.form.nomecidadeinternacionalescola = '';
          this.form.nomepaisinternacionalescola = '';
        } else {
          this.form.codigologradouro = '';
          this.form.descricaocomplementoendereco = '';
          this.form.numeroimovel = '';
        }

        if (val.tiposituacaofuncionamento != '3') {
          this.form.dataextincao = '';
        }
      },
      deep: true,
    },
  },
  methods: {
    getTipoDependenciaAdministrativa(tipo) {
      switch (tipo) {
        case '1': return 'Federal';
        case '2': return 'Estadual';
        case '3': return 'Municipal';
        case '4': return 'Privada';
        default: return '';
      }
    },
    exibeDependencia() {
      if (this.acao == '' && !this.form.codigologradouro) { return ''; }

      return this.getTipoDependenciaAdministrativa(this.form.tipodependenciaadministrativa);
    },
    exibeSituacao() {
      if (this.acao == '' && !this.form.codigologradouro) { return ''; }

      switch (this.form.tiposituacaofuncionamento) {
        case '1': return 'Em Atividade';
        case '2': return 'Paralisada';
        case '3': return 'Extinta';
        default: return '';
      }
    },
    exibeZonaLocalizacao() {
      if (this.acao == '' && !this.form.codigologradouro) { return ''; }

      switch (this.form.tipozonalocalizacao) {
        case '1': return 'Urbana';
        case '2': return 'Rural';
        default: return '';
      }
    },
    novaEscola() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.form = {
        ...this.form,
        nomesuperitendenciaensino: 'Superintendência Regional de Ensino de Coronel Fabriciano',
      };
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarEscola() {
      if (this.form.identificadorescola !== '') {
        this.acao = 'editar';
      }
    },
    async excluirEscola() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta escola?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/escola/${this.form.identificadorescola}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    cancelarEscola() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        const response = await api({
          method: (this.acao === 'novo') ? 'post' : 'put',
          url: `gerencial/escola${(this.acao === 'novo') ? '' : `/${this.form.identificadorescola}`}`,
          data: {
            ...this.form,
            datapublicacaoportaria: (this.form.datapublicacaoportaria) ? moment(this.form.datapublicacaoportaria, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
            datainiciofuncionamento: (this.form.datainiciofuncionamento) ? moment(this.form.datainiciofuncionamento, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
            dataextincao: (this.form.dataextincao) ? moment(this.form.dataextincao, 'DD/MM/YYYY').format('YYYY-MM-DD'): '',
          },
        });

        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        if (this.acao == '') { this.form = { ...response.data.results,
                                            datapublicacaoportaria: (response.data.results.datapublicacaoportaria) ? moment(response.data.results.datapublicacaoportaria, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                                            datainiciofuncionamento: (response.data.results.datainiciofuncionamento) ? moment(response.data.results.datainiciofuncionamento, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                                            dataextincao: (response.data.results.dataextincao) ? moment(response.data.results.dataextincao, 'YYYY-MM-DD').format('DD/MM/YYYY'): '',

                            }; }
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
      return true;
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = {
        ...dados,
        numeroinep: ((dados.numeroinep !== null) ? dados.numeroinep.trim() : null),
        numeroportariaseesme: ((dados.numeroportariaseesme !== null) ? dados.numeroportariaseesme.trim() : null),
        datapublicacaoportaria: (dados.datapublicacaoportaria) ? moment(dados.datapublicacaoportaria, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
        datainiciofuncionamento: (dados.datainiciofuncionamento) ? moment(dados.datainiciofuncionamento, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
        dataextincao: (dados.dataextincao) ? moment(dados.dataextincao, 'YYYY-MM-DD').format('DD/MM/YYYY'): ''
      };
      this.formUltimo = { ...this.form };
    },
    validacaoEndereco() {
      return (this.$v.form.codigologradouro.$invalid && this.$v.form.codigologradouro.$dirty);
    },
    desabilitarCampos() {
      return (this.acao == 'editar') ? (this.acao == '' || this.form.tiposituacaofuncionamento == 3) : this.acao == '';
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
    textoBuscaApi(dados) {
      let nomeCidade = '';
      let tipoDependenciaAdministrativa = '';

      if (dados.tipodependenciaadministrativa) { tipoDependenciaAdministrativa = `, ${this.getTipoDependenciaAdministrativa(dados.tipodependenciaadministrativa)}`; }

      if (dados.logradouro.nomecidade || dados.nomecidadeinternacionalescola) { nomeCidade = ` - ${((dados.logradouro) ? dados.logradouro.nomecidade : dados.nomecidadeinternacionalescola).toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())}`; }

      return `${dados.nomeescola}${tipoDependenciaAdministrativa}${nomeCidade}`;
    },
  },
};
</script>

<style lang="scss">
.escola-card-dados{
  display: block;
  padding: 10px 16px;

  &> div {
    margin: 3px 0px;
  }

  .escola-card-dados-itens{
    display: flex;
    flex-wrap: wrap;
    div{
      margin-right: 7%;
      white-space: nowrap;
    }
  }
}
</style>
